/*
  vuex相关通用方法mix by.qiushangzhe 2020-01-22
*/

// 首先是跟登录的用户相关的数据
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isLogin: 'userInfoModule/isLogin'
    })
  },
  methods: {
    // 在 `some/nested/module` 中查找
    ...mapActions({
      initUserInfo: 'userInfoModule/initUserInfo'
    })
  }
}
